import { __decorate } from "tslib";
import { injectable } from '@/inversify.config';
import { DEPLOY_ENV } from '@cores/constants/envConfig';
import _ from 'lodash';
import { REGION_LIST, REQUEST_DEMO_LINK_TEMPLATE_MAP, HELPER_CENTER_LINK_CN, HELPER_CENTER_LINK_US, SYNAPSE_HIDDEN_KEY_MAP } from './constants';
import { transformUrlProxy, SLD } from '@patsnap-utils/biz';
import { ViewType } from '@/domains/base/enums/view-type';
const localRegion = localStorage.getItem('_MOCK_SITE_REGION_');
const currentEnv = _.toUpper(localRegion || DEPLOY_ENV);
let FeatureConfigImpl = class FeatureConfigImpl {
    get region() {
        return _.includes(REGION_LIST, currentEnv) ? currentEnv : 'CN';
    }
    get isCN() {
        return this.region === 'CN';
    }
    get isEU() {
        return this.region === 'EU';
    }
    get isUS() {
        return this.region === 'US';
    }
    get helpCenterLinkAboutAiTagging() {
        const url = this.isCN ? HELPER_CENTER_LINK_CN.AI_TAGGING : HELPER_CENTER_LINK_US.AI_TAGGING;
        return this.transformHelperCenterUrlProxy(url);
    }
    get helpCenterLinkAboutCustomField() {
        const url = this.isCN ? HELPER_CENTER_LINK_CN.CUSTOM_FIELD : HELPER_CENTER_LINK_US.CUSTOM_FIELD;
        return this.transformHelperCenterUrlProxy(url);
    }
    get helpCenterLinkAboutEmptyData() {
        const url = this.isCN ? HELPER_CENTER_LINK_CN.EMPTY_DATA : HELPER_CENTER_LINK_US.EMPTY_DATA;
        return this.transformHelperCenterUrlProxy(url);
    }
    get helpCenterLinkAboutSpaceTransfer() {
        const url = this.isCN ? HELPER_CENTER_LINK_CN.SPACE_TRANSFER : HELPER_CENTER_LINK_US.SPACE_TRANSFER;
        return this.transformHelperCenterUrlProxy(url);
    }
    get helpCenterLinkAboutCompanySpace() {
        const url = this.isCN ? HELPER_CENTER_LINK_CN.COMPANY_SPACE : HELPER_CENTER_LINK_US.COMPANY_SPACE;
        return this.transformHelperCenterUrlProxy(url);
    }
    get helpCenterLinkAboutSpaceShare() {
        const url = this.isCN ? HELPER_CENTER_LINK_CN.SPACE_SHARE : HELPER_CENTER_LINK_US.SPACE_SHARE;
        return this.transformHelperCenterUrlProxy(url);
    }
    get requestDemoLinkTemplate() {
        return this.isCN ? REQUEST_DEMO_LINK_TEMPLATE_MAP.CN : REQUEST_DEMO_LINK_TEMPLATE_MAP.US;
    }
    get synapseHiddenKey() {
        return this.isCN ? SYNAPSE_HIDDEN_KEY_MAP.CN : SYNAPSE_HIDDEN_KEY_MAP.US;
    }
    get isImageTextShowAllFamily() {
        return !this.isCN;
    }
    get isShowJpTranslation() {
        return !this.isCN;
    }
    get enableLabFeature() {
        return this.isCN;
    }
    get enableStandardCompanyProfile() {
        return !this.isCN;
    }
    get defaultViewTypeByRegion() {
        return this.isCN ? ViewType.TABLE : ViewType.STANDARD;
    }
    transformHelperCenterUrlProxy(url) {
        return transformUrlProxy(SLD.HELP, url);
    }
};
FeatureConfigImpl = __decorate([
    injectable()
], FeatureConfigImpl);
export { FeatureConfigImpl };
